import React from 'react';

import { Spin } from 'components';

import {
  IBlockWrapperDescriptionProps,
  IBlockWrapperHeaderProps,
  IBlockWrapperProps,
  IBlockWrapperTitleProps,
} from './BlockWrapper.types';

import './BlockWrapper.styles.scss';

const BlockWrapper = ({
  children,
  noPadding,
  noBorderRadius,
  stretch,
  loading,
  className = '',
  ...props
}: IBlockWrapperProps) => (
  <div
    className={`np-block-wrapper
     ${className ?? ''}
     ${noPadding ? 'np-block-wrapper--no-padding' : ''}
     ${stretch ? 'np-block-wrapper--stretch' : ''}
     ${noBorderRadius ? 'np-block-wrapper--no-border-radius' : ''}
     `}
    {...props}
  >
    {loading ? <Spin /> : children}
  </div>
);

BlockWrapper.Title = ({
  children,
  className = '',
  size,
  noPadding = true,
  style,
  ...props
}: IBlockWrapperTitleProps) => (
  <div
    className={`np-block-wrapper__title ${className ? className : ''} ${
      size === 'large' ? 'np-block-wrapper__title--large' : ''
    }`}
    style={{ padding: noPadding && 0, ...style }}
    {...props}
  >
    {children}
  </div>
);

BlockWrapper.Header = ({ children, className = '', noPadding, style, ...props }: IBlockWrapperHeaderProps) => (
  <div
    className={`np-block-wrapper__header ${className ?? ''}`}
    style={{ padding: noPadding && '0px', ...style }}
    {...props}
  >
    {children}
  </div>
);

BlockWrapper.Description = ({ children, className = '', ...props }: IBlockWrapperDescriptionProps) => (
  <div className={`np-block-wrapper__description ${className ?? ''}`} {...props}>
    {children}
  </div>
);

export default BlockWrapper;
